// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  const overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  if (loadingSpinner) {
  loadingSpinner.classList.toggle('hidden');
  }
}

function moveWithHover(image, event, zoomRatio) {
  // Find the overlay for this image
  const overlay = document.querySelector('.image-magnify-full-size');
  if (!overlay) return;
  
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio, selector) {
  // Target both classes that are used in the modal
  const targetSelector = selector || '.image-magnify-hover, .image-magnify-lightbox';
  const images = document.querySelectorAll(targetSelector);
  
  images.forEach((image) => {
    // Remove existing click handler to avoid duplicates
    const newImage = image.cloneNode(true);
    image.parentNode.replaceChild(newImage, image);
    
    newImage.onclick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      
      // Remove any existing overlays
      const existingOverlays = document.querySelectorAll('.image-magnify-full-size');
      existingOverlays.forEach(overlay => overlay.remove());
      
      // Add CSS animation if not already present
      if (!document.querySelector('#zoom-spinner-styles')) {
        const style = document.createElement('style');
        style.id = 'zoom-spinner-styles';
        style.textContent = `
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `;
        document.head.appendChild(style);
      }
      
      // Get image position
      const imageRect = newImage.getBoundingClientRect();
      
      // Find the spinner closest to this image (in the same parent container)
      let spinner = newImage.closest('.product__modal-opener')?.querySelector('.loading__spinner')
                    || newImage.parentElement?.querySelector('.loading__spinner')
                    || newImage.parentElement?.parentElement?.querySelector('.loading__spinner')
                    || newImage.closest('.product')?.querySelector('.loading__spinner')
                    || newImage.closest('.product-modal')?.querySelector('.loading__spinner');
      
      if (!spinner) {
        return;
      }
      
      // Reset and position spinner over the clicked image
      spinner.classList.remove('hidden');
      spinner.style.position = 'fixed';
      spinner.style.top = `${imageRect.top + imageRect.height / 2}px`;
      spinner.style.left = `${imageRect.left + imageRect.width / 2}px`;
      spinner.style.transform = 'translate(-50%, -50%)';
      spinner.style.zIndex = '99999';
      spinner.style.display = 'flex';
      
      // Create enlarged image
      const enlargedImg = document.createElement('img');
      
      // Track when spinner was shown
      const spinnerStartTime = Date.now();
      const minSpinnerTime = 300; // Minimum 300ms to see spinner
      
      // Load the image
      enlargedImg.onload = () => {
        const elapsedTime = Date.now() - spinnerStartTime;
        const remainingTime = Math.max(0, minSpinnerTime - elapsedTime);
        
        // Wait minimum time before hiding spinner
        setTimeout(() => {
          // Hide spinner
          spinner.classList.add('hidden');
          spinner.style.display = '';
          spinner.style.position = '';
          spinner.style.top = '';
          spinner.style.left = '';
          spinner.style.transform = '';
          spinner.style.zIndex = '';
        
        // Create lightbox overlay
        const overlay = document.createElement('div');
        overlay.className = 'image-magnify-full-size';
        overlay.style.cssText = `
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.9);
          z-index: 10000;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        `;
        
        enlargedImg.style.cssText = `
          max-width: 90%;
          max-height: 90%;
          object-fit: contain;
          border-radius: 8px;
        `;
        
        overlay.appendChild(enlargedImg);
        document.body.appendChild(overlay);
        
          // Close on click
          overlay.onclick = () => overlay.remove();
        }, remainingTime);
      };
      
      enlargedImg.onerror = () => {
        // Hide spinner on error
        spinner.classList.add('hidden');
        spinner.style.display = '';
        spinner.style.position = '';
        spinner.style.top = '';
        spinner.style.left = '';
        spinner.style.transform = '';
        spinner.style.zIndex = '';
        alert('Failed to load image');
      };
      
      // Start loading the image
      enlargedImg.src = newImage.src;
    };
  });
}

enableZoomOnHover(2);
